import { upperCaseFirst } from '@neo-one/utils';
export const createForwardedValueFuncArgsName = (func) => `forward${upperCaseFirst(func.name)}Args`;
export const createForwardedValueFuncReturnName = (func) => `forward${upperCaseFirst(func.name)}Return`;

//# sourceMappingURL=utils.js.map
